import React, { useEffect, useState } from "react";
import { Box, IconButton } from "@mui/material";
import { Delete, Edit } from "@mui/icons-material";
import TransitionsModal from "../components/Modal";
import AdminLayout from "../layouts/AdminLayout";
import { BeatLoader } from "react-spinners";
import axios from "axios";
import { toast } from "react-toastify";
import { Icon } from "@iconify/react";
import { deleteApi, getApi, postApi } from "../config/configAxios";
import Swal from "sweetalert2";
import CustomLoader from "../components/CustomLoader";
import JoditEditor from "jodit-react";
import { config } from "../utils/JoditConfig";

const Officer = () => {
  const [data, setData] = useState([]);
  const [storeData, setStoreData] = useState({});
  const [editData, setEditData] = useState({});
  const [loading, setLoading] = useState(true);
  const [openStore, setOpenStore] = useState(false);
  const [openEdit, setOpenEdit] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const fetchData = async () => {
    try {
      const res = await getApi("officer");
      setData(res.data.data);
    } catch (err) {
      toast.error(err?.message);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchData();
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setStoreData((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setStoreData((prevData) => ({ ...prevData, file: file }));
  };

  /// store
  const handleStore = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    const formData = new FormData();
    formData.append("name", storeData.name);
    formData.append("title", storeData.title);
    formData.append("designation", storeData.designation);
    formData.append("index", storeData.index);
    formData.append("file", storeData.file);
    formData.append("content", storeData.content);
    formData.append("mobile", storeData.mobile);
    formData.append("email", storeData.email);
    formData.append("phone", storeData.phone);
    formData.append("fax", storeData.fax);
    formData.append("batch", storeData.batch);
    formData.append("joining_date", storeData.joining_date);

    try {
      await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}store-officer`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      setOpenStore(false);
      setStoreData({});
      fetchData();
      toast.success("Data created successfully!");
    } catch (err) {
      toast.error(err?.response?.data?.error || "update failed");
    } finally {
      setIsSubmitting(false);
    }
  };

  // delete
  const handleDelete = async (id) => {
    Swal.fire({
      title: "Confirm delete",
      text: "Are you sure you want to delete this?",
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          try {
            await deleteApi(`delete-officer/${id}`)
              .then((res) => {
                toast.success("Data deleted successfully!");
              })
              .catch((err) => {
                toast.error("An error occurred while updating status");
              })
              .finally(() => {
                fetchData();
              });
          } catch (err) {
            toast.error(err?.response?.data?.error || "update failed");
          }
        } catch (error) {
          Swal.fire(
            "Error",
            "An error occurred while delete the user.",
            "error"
          );
        }
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire("Cancelled", "The user was not deleted.", "info");
      }
    });
  };

  // edit
  const handleEdit = async (id) => {
    setOpenEdit(true);
    try {
      const res = await getApi(`find-officer/${id}`);
      setEditData(res.data.data);
      setStoreData(res.data.data);
    } catch (err) {
      toast.error(err?.message);
    }
  };
  // handleUpdate
  const handleUpdate = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    const formData = new FormData();
    formData.append("name", storeData.name);
    formData.append("title", storeData.title);
    formData.append("designation", storeData.designation);
    formData.append("index", storeData.index);
    formData.append("file", storeData.file);
    formData.append("content", storeData.content);
    formData.append("mobile", storeData.mobile);
    formData.append("email", storeData.email);
    formData.append("phone", storeData.phone);
    formData.append("fax", storeData.fax);
    formData.append("batch", storeData.batch);
    formData.append("joining_date", storeData.joining_date);
    try {
      await postApi(
        `${process.env.REACT_APP_API_BASE_URL}update-officer/${editData.id}`,
        formData
      );
      setOpenEdit(false);
      setStoreData({});
      fetchData();
      toast.success("Data updated successfully!");
    } catch (err) {
      toast.error(err?.response?.data?.error || "update failed");
    } finally {
      setIsSubmitting(false);
    }
  };
  return (
    <AdminLayout title={"Officer"}>
      {loading ? (
        <CustomLoader />
      ) : (
        <div>
          <div className="flex justify-between p-3">
            <h1 className="text-gray-700 font-medium">Officer list</h1>
            <div>
              <button className="btn-indigo" onClick={() => setOpenStore(true)}>
                Add officer
              </button>
            </div>
          </div>
          <div className="table-wrap">
            <table className="table-main shadow-md">
              <thead className="table-h">
                <tr>
                  <th className="table-h">SN</th>
                  <th className="table-h">Name</th>
                  <th className="table-h">Photo</th>
                  <th className="table-h">Designation</th>
                  <th className="table-h">Title</th>
                  <th className="table-h">Index</th>
                  <th className="table-h">Action</th>
                </tr>
              </thead>
              <tbody className="table-b">
                {data.map((item, index) => (
                  <tr key={item.id}>
                    <td className="table-b">{index + 1}</td>
                    <td className="table-b">{item?.name}</td>
                    <td className="table-b">
                      <img
                        className="h-10 rounded-lg"
                        src={`${process.env.REACT_APP_API_FILE_URL}${item.file}`}
                        alt=""
                      />
                    </td>
                    <td className="table-b">{item?.designation}</td>
                    <td className="table-b">{item?.title}</td>
                    <td className="table-b">{item?.index}</td>
                    <td className="table-b">
                      <Box display="flex">
                        <IconButton
                          className="mr-3"
                          onClick={() => handleDelete(item.id)}
                        >
                          <Delete className="text-red-500" />
                        </IconButton>
                        <IconButton
                          className="mr-3"
                          onClick={() => handleEdit(item.id)}
                        >
                          <Edit className="text-blue-500" />
                        </IconButton>
                      </Box>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {/* modal  */}

      <TransitionsModal title={"Add"} open={openStore} setOpen={setOpenStore}>
        <form className="" onSubmit={handleStore}>
          <div className="grid md:grid-cols-2 grid-cols-1 gap-6">
            <div>
              <label htmlFor="title" className="font-semibold text-sm">
                Title
              </label>
              <input
                type="text"
                id="title"
                name="title"
                onChange={handleInputChange}
                className="form-control"
              />
            </div>
            <div>
              <label htmlFor="name" className="font-semibold text-sm">
                Name
              </label>
              <input
                type="text"
                id="name"
                name="name"
                onChange={handleInputChange}
                className="form-control"
              />
            </div>
            <div>
              <label htmlFor="designation" className="font-semibold text-sm">
                Designation
              </label>
              <input
                type="text"
                id="designation"
                name="designation"
                onChange={handleInputChange}
                className="form-control"
              />
            </div>

            <div>
              <label htmlFor="index" className="font-semibold text-sm">
                Index
              </label>
              <input
                type="text"
                id="index"
                name="index"
                onChange={handleInputChange}
                className="form-control"
              />
            </div>
            <div>
              <label htmlFor="mobile" className="font-semibold text-sm">
                Mobile
              </label>
              <input
                type="text"
                id="mobile"
                name="mobile"
                onChange={handleInputChange}
                className="form-control"
              />
            </div>
            <div>
              <label htmlFor="email" className="font-semibold text-sm">
                Email
              </label>
              <input
                type="email"
                id="email"
                name="email"
                onChange={handleInputChange}
                className="form-control"
              />
            </div>
            <div>
              <label htmlFor="phone" className="font-semibold text-sm">
                Phone
              </label>
              <input
                type="text"
                id="phone"
                name="phone"
                onChange={handleInputChange}
                className="form-control"
              />
            </div>
            <div>
              <label htmlFor="fax" className="font-semibold text-sm">
                Address
              </label>
              <input
                type="text"
                id="fax"
                name="fax"
                onChange={handleInputChange}
                className="form-control"
              />
            </div>
            <div>
              <label htmlFor="batch" className="font-semibold text-sm">
                Batch
              </label>
              <input
                type="text"
                id="batch"
                name="batch"
                onChange={handleInputChange}
                className="form-control"
              />
            </div>
            <div>
              <label htmlFor="joining_date" className="font-semibold text-sm">
                Joining Date
              </label>
              <input
                type="date"
                id="joining_date"
                name="joining_date"
                onChange={handleInputChange}
                className="form-control"
              />
            </div>
            <div className="md:col-span-2">
              <label htmlFor="file" className="font-semibold text-sm">
                Photo
              </label>
              <input
                type="file"
                id="file"
                name="file"
                onChange={handleFileChange}
                className="form-control"
              />
            </div>
            {storeData?.file && typeof storeData?.file !== "string" && (
              <div>
                <label htmlFor="file" className="font-semibold text-sm">
                  New Photo
                </label>
                <img
                  className="h-20 border border-dashed rounded-md p-3"
                  src={URL.createObjectURL(storeData?.file)}
                  alt="Preview"
                />
              </div>
            )}

            <div className="md:col-span-2">
              <JoditEditor
                config={config}
                tabIndex={1}
                value={storeData?.content}
                onBlur={(newContent) =>
                  setStoreData((prevData) => ({
                    ...prevData,
                    content: newContent,
                  }))
                }
              />
            </div>
            <div className="md:col-span-2">
              <button
                disabled={isSubmitting}
                type="submit"
                className="btn-green w-full"
                data-ripple-light="true"
              >
                {isSubmitting ? <BeatLoader color="#fff" /> : "Submit"}
              </button>
            </div>
          </div>
        </form>
      </TransitionsModal>
      <TransitionsModal title={"Edit"} open={openEdit} setOpen={setOpenEdit}>
        <form className="" onSubmit={handleUpdate}>
          <div className="grid md:grid-cols-2 grid-cols-1 gap-6">
            <div>
              <label htmlFor="title" className="font-semibold text-sm">
                Title
              </label>
              <input
                type="text"
                id="title"
                name="title"
                value={storeData?.title}
                onChange={handleInputChange}
                className="form-control"
              />
            </div>
            <div>
              <label htmlFor="name" className="font-semibold text-sm">
                Name
              </label>
              <input
                type="text"
                id="name"
                name="name"
                value={storeData?.name}
                onChange={handleInputChange}
                className="form-control"
              />
            </div>
            <div>
              <label htmlFor="designation" className="font-semibold text-sm">
                Designation
              </label>
              <input
                type="text"
                id="designation"
                name="designation"
                value={storeData?.designation}
                onChange={handleInputChange}
                className="form-control"
              />
            </div>
            <div>
              <label htmlFor="index" className="font-semibold text-sm">
                Index
              </label>
              <input
                type="text"
                id="index"
                name="index"
                value={storeData?.index}
                onChange={handleInputChange}
                className="form-control"
              />
            </div>
            <div>
              <label htmlFor="mobile" className="font-semibold text-sm">
                Mobile
              </label>
              <input
                type="text"
                id="mobile"
                name="mobile"
                value={storeData?.mobile}
                onChange={handleInputChange}
                className="form-control"
              />
            </div>
            <div>
              <label htmlFor="email" className="font-semibold text-sm">
                Email
              </label>
              <input
                type="email"
                id="email"
                name="email"
                value={storeData?.email}
                onChange={handleInputChange}
                className="form-control"
              />
            </div>
            <div>
              <label htmlFor="phone" className="font-semibold text-sm">
                Phone
              </label>
              <input
                type="text"
                id="phone"
                name="phone"
                value={storeData?.phone}
                onChange={handleInputChange}
                className="form-control"
              />
            </div>
            <div>
              <label htmlFor="fax" className="font-semibold text-sm">
                Address
              </label>
              <input
                type="text"
                id="fax"
                name="fax"
                value={storeData?.fax}
                onChange={handleInputChange}
                className="form-control"
              />
            </div>
            <div>
              <label htmlFor="batch" className="font-semibold text-sm">
                Batch
              </label>
              <input
                type="text"
                id="batch"
                name="batch"
                value={storeData?.batch}
                onChange={handleInputChange}
                className="form-control"
              />
            </div>
            <div>
              <label htmlFor="joining_date" className="font-semibold text-sm">
                Joining Date
              </label>
              <input
                type="date"
                id="joining_date"
                name="joining_date"
                value={storeData?.joining_date}
                onChange={handleInputChange}
                className="form-control"
              />
            </div>

            <div className="md:col-span-2">
              <label htmlFor="file" className="font-semibold text-sm">
                Photo
              </label>
              <input
                type="file"
                id="file"
                name="file"
                onChange={handleFileChange}
                className="form-control"
              />
            </div>
            <div className="grid grid-cols-2 gap-6">
              <div className="mr-3 ">
                <label htmlFor="file" className="font-semibold text-sm">
                  Old Photo
                </label>
                <img
                  className="h-20 border border-dashed rounded-md p-3"
                  src={`${process.env.REACT_APP_API_FILE_URL}${editData?.file}`}
                  alt=""
                />
              </div>
              <div>
                {storeData?.file && typeof storeData?.file !== "string" && (
                  <>
                    <label htmlFor="file" className="font-semibold text-sm">
                      New Photo
                    </label>
                    <img
                      className="h-20 border border-dashed rounded-md p-3"
                      src={URL.createObjectURL(storeData?.file)}
                      alt="Preview"
                    />
                  </>
                )}
              </div>
            </div>
            <div className="md:col-span-2">
              <JoditEditor
                config={config}
                tabIndex={1}
                value={storeData?.content}
                onBlur={(newContent) =>
                  setStoreData((prevData) => ({
                    ...prevData,
                    content: newContent,
                  }))
                }
              />
            </div>
            <div className="md:col-span-2">
              <button
                disabled={isSubmitting}
                type="submit"
                className="btn-green w-full"
                data-ripple-light="true"
              >
                {isSubmitting ? <BeatLoader color="#fff" /> : "Update"}
              </button>
            </div>
          </div>
        </form>
      </TransitionsModal>
    </AdminLayout>
  );
};

export default Officer;
